@let request = requestInput();
<fieldset>
  <legend class="keyLabel">Performance Inputs</legend>
  <div class="content">
    <div class="inputRow">
      <span>
        <label class="inputLabel">Fan Speed:</label>
        <select class="inputSelection fanSpeedSelection" #fanSpeedInput [(ngModel)]="request.fanSpeed" (change)="localInputChanged('USFSpeed', fanSpeedInput.value)">
          <option [value]="'H'">High</option>
          <option [value]="'M'">Medium</option>
          <option [value]="'L'">Low</option>
          <option [value]="'C'">ECM Design Airflow</option>
        </select>
      </span>
      <label class="inputLabel">Airflow:</label>
      <input type="number" class="inputValue" [(ngModel)]="request.airflow" #airflowInput (change)="localInputChanged('USFAirflow', airflowInput.value)"/>
      <label class="unitLabel">{{ getAirflowUnits() }}</label>
      <label class="inputLabel">ESP:</label>
      <input type="number" class="inputValue" [(ngModel)]="request.externalStaticPressure" #espInput (change)="localInputChanged('USFESP', espInput.value)"/>
      <label class="unitLabel">{{ getEspUnits() }}</label>
      <label class="inputLabel">Altitude:</label>
      <input type="number" class="inputValue" [(ngModel)]="request.altitude" #altitudeInput (change)="localInputChanged('USAltitude', altitudeInput.value)"/>
      <label class="unitLabel">{{ getLengthUnits() }}</label>
    </div>
    <div class="inputRow">
      @if (request.primaryCoilRequest) {
        <div class="coilRatingContainer">
          <app-sure-flow-performance-coil-input [coilRequest]="request.primaryCoilRequest" [unitData]="unitData()"
            (inputChanged)="inputChanged($event)" [fieldLabel]="'Primary Coil'"
            [metricInput]="request.metric">
          </app-sure-flow-performance-coil-input>
        </div>
      }
      @if (request.secondaryCoilRequest) {
        <div class="coilRatingContainer">
          <app-sure-flow-performance-coil-input [coilRequest]="request.secondaryCoilRequest" [unitData]="unitData()"
            (inputChanged)="inputChanged($event)" [fieldLabel]="'Secondary Coil'"
            [metricInput]="request.metric">
          </app-sure-flow-performance-coil-input>
        </div>
      }
      @if (request.electricHeatRequest) {
        <div class="coilRatingContainer">
          <app-sure-flow-performance-coil-input [coilRequest]="request.electricHeatRequest"
            (inputChanged)="inputChanged($event)" [fieldLabel]="'Electric Heat'"
            [metricInput]="request.metric">
          </app-sure-flow-performance-coil-input>
        </div>
      }
    </div>
  </div>
</fieldset>
